// extracted by mini-css-extract-plugin
module.exports = {"notFound":"_404_notFound_3Vnhp"};